import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>Reid.id crafts unique, handmade perfumes for the modern individual.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/shop">Shop</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact Us</h3>
            <p>Email: -</p>
            <p>Phone: -</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2023 Reid.id. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

